import { Component, Inject, Input } from "@angular/core";
import { DespachoService } from "../../../../services/despacho/despacho.service";
import { AppState } from "../../../../app.state";
import { select, Store } from "@ngrx/store";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { LoadingService } from "../../../../loading/loading.service";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { selectUsuario } from "../../../../states/usuario/selector";
import { quitarTemaNotificarDespacho } from "../../../../states/despacho/actions";
import { IQuitarTema, ITemaEliminado } from "../../../../interfaces/despacho";

@Component({
  selector: "app-quitar-tema",
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  templateUrl: "./quitar-tema.component.html",
  styleUrl: "./quitar-tema.component.css",
})
export class QuitarTemaComponent {
  @Input() tema!: any;
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  justificacion = new FormControl("", [Validators.required]);
  public catJustificacion: any[] = [];
  constructor(
    private store: Store<AppState>,
    public dialogRef: MatDialogRef<QuitarTemaComponent>,
    public despachoService: DespachoService,
    public dialog: MatDialog,
    public loadingService: LoadingService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}
  ngOnInit(): void {
    this.despachoService.getJustipfiicacion("").subscribe((data) => {
      console.log("data", data);
      this.catJustificacion = data;
    });
  }
  async save() {
    this.dialogRef.close();
    this.loadingService.show();
    const user = structuredClone(this.stateUser.state().usuario);
    console.log("user", user);

    let quitarTema: IQuitarTema = {
      id_tema: this.data.id_tema,
      justificacion: this.justificacion.value ?? "",
      id_tipo_forma: 2,
      id_usuario: user.uid,
      usuario: user.nombre,
    };

    const temaEliminado: ITemaEliminado = {
      nombreUsuario: user.nombre,
      nombreTema: this.data.nombreTema,
      descripcionTema: this.data.descripcionTema,
      justificacion: this.justificacion.value ?? "",
      id_empresa: this.data.id_empresa,
      notificacion: "temaEliminado",
    };

    console.log("quitarTema", quitarTema);
    console.log("temaEliminado", temaEliminado);

    try {
      const quitarTemaResp = await this.despachoService.quitarTema(quitarTema);
      const temaEliminadoResp = await this.despachoService.temaEliminado(
        temaEliminado
      );

      if (!quitarTemaResp.error && !temaEliminadoResp.error) {
        this.store.dispatch(
          quitarTemaNotificarDespacho({ quitarTema, temaEliminado })
        );
      }
    } catch (error) {
      this.loadingService.hide();
    }
  }
}
